import React, { useState } from 'react';
// Import the progress bar component
import { Container, Row, Col, Button, Form } from 'react-bootstrap';

const Step4 = () => {
    const [vestingSchedule, setVestingSchedule] = useState([
        { date: '', percentage: '' }
    ]);

    const handleVestingChange = (index, field, value) => {
        const newSchedule = [...vestingSchedule];
        newSchedule[index][field] = value;
        setVestingSchedule(newSchedule);
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic
    };

    return (
        <>
            <Form onSubmit={handleSubmit}>
                {/* Initial Release (TGE) */}
                <Form.Group controlId="tgeDate">
                    <Form.Label>Initial Release (TGE) Date & Time</Form.Label>
                    <Form.Control type="datetime-local" required />
                </Form.Group>

                <hr className="my-4" />

                {/* Additional Releases (Vesting) */}
                <h5 className='mb-3'>Vesting Schedule</h5>
               
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Unlock Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label>Unlock Percentage (%)</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="e.g., 20"
                                    min="0"
                                    max="100"
                                    required
                                />
                            </Form.Group>
                        </Col>
                        
                    </Row>

              

            </Form>
        </>
    );
};

export default Step4;
